<div class="container-fluid widget-wrapper">
  <div class="row widget-header">
    <div class="col-lg-12">
      <h2>
        Invalid Traffic (IVT)
        <a class="btn btn-link help-icon p-0 invisible" data-placement="top" data-toggle="tooltip" enTooltip
           title="">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon"/>
        </a>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body p-0">
    <div class="col-lg-12">
      <domain-ivt [data]="data" [appName]="data?.appOverview?.title"></domain-ivt>
    </div>
  </div>
</div>

<div class="container-fluid widget-wrapper fraud-types mt-4"
     *ngIf="data && (data?.ivtDistribution?.givtFraudTypes?.length > 0 || data && data?.ivtDistribution?.sivtFraudTypes?.length > 0)">
  <div class="row widget-header">
    <div class="col-lg-12">
      <h2>Invalid Traffic (IVT) Types
        <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
           title="The percentage of invalid traffic associated with each Pixalate's taxonomy of GIVT and SIVT invalid traffic types">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon"/>
        </a>
      </h2>
    </div>
  </div>
  <div class="row widget-body p-0">
    <div class="col-lg-12">
      <app-domain-fraudtypes [data]="data"></app-domain-fraudtypes>
    </div>
  </div>
</div>

<div class="container-fluid widget-wrapper mt-4" *ngIf="data && data?.ivtDistribution?.datacenters?.length > 0">
  <div class="row widget-header">
    <div class="col-lg-12">
      <h2>Invalid Traffic (IVT) by Data Centers</h2>
    </div>
  </div>
  <div class="row widget-body p-0">
    <div class="col-lg-12">
      <app-domain-fraud-traffic [data]="data"></app-domain-fraud-traffic>
    </div>
  </div>
</div>
